import {Color} from '@material-ui/lab';

export class AppAlert {
  constructor(public message: string, public type: Color) {}
}
